import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { C1Alert, C1AlertTitle } from 'c1ui'
import { C1Chip } from 'c1ui/components/C1Chip'
import { C1EntitlementDisplayNameWithFetch } from 'components/pages/entitlement/display-name'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Expression } from './expressionParser'

export const ExpressionPartReadOnly = ({ expression, truncate }: { expression: Expression, truncate?: boolean }): ReactNode => {
    switch (expression.type) {
        case 'hasEntitlement':
            if (!expression.appId || !expression.appEntitlementId) {
                return <C1Alert>
                    <C1AlertTitle>
                        <FormattedMessage id="expressionBuilder.entitlementNotSelected" defaultMessage="Entitlement not selected" />
                    </C1AlertTitle>
                </C1Alert>
            }
            return <Box sx={{ padding: 1 }}>
                <C1EntitlementDisplayNameWithFetch
                    appId={expression.appId}
                    entitlementId={expression.appEntitlementId}
                    textTruncationWidth={truncate ? '32em' : undefined}
                />
            </Box>
        case 'profileEquals':
            return <Stack direction="row" spacing={1}>
                <C1Chip
                    label={<Typography variant="caption" color="primary.main">{ expression.field }</Typography>}
                    color="primary"
                />
                <Typography variant="caption" color="primary.main">
                    <FormattedMessage
                        id="expression_equals"
                        defaultMessage="="
                    />
                </Typography>
                <C1Chip
                    label={<Typography variant="caption" color="primary.main">{ expression.value }</Typography>}
                    color="primary"
                />
            </Stack>
        case 'and':
            return <FormattedMessage defaultMessage="AND" id="expression_and_condition" />
        case 'or':
            return <FormattedMessage defaultMessage="OR" id="expression_or_condition" />
        default:
            return <C1Alert>
                <C1AlertTitle>
                    <FormattedMessage id="expressionBuilder.unknownExpressionType" defaultMessage="Unknown expression type" />
                </C1AlertTitle>
            </C1Alert>
    }
}
